import { useEffect, useState } from "react";
import Post from "../../types/Post";
import { dates } from "../../utils/date";
import styles from "./styles.module.scss";

interface ComponentTypes {
  data: Post;
}

export const DisplayDate = ({ data }: ComponentTypes) => {
  const { dateFormat: dateCreated, hour: hourCreated } = dates(data.date);
  const {
    dateFormat: dataModificada,
    weekday,
    hour: horaModificada,
  } = dates(data.modified);
  const [dateWasModified, setDateWasModified] = useState(false);

  const longDataCreated = new Date(data.date);
  const longDataModified = new Date(data.modified);

  const excludeLast4StrCre = String(longDataCreated.getTime()).slice(0, -4);
  const excludeLast4StrMod = String(longDataModified.getTime()).slice(0, -4);

  useEffect(() => {
    if (excludeLast4StrMod > excludeLast4StrCre) {
      setDateWasModified(true);
    }
  }, [excludeLast4StrCre, excludeLast4StrMod]);

  return (
    <>
      <time className={styles.articleDate} dateTime={data.date}>
        Postagem Criada em: {dateCreated} às {hourCreated}
      </time>
      {dateWasModified && (
        <time className={styles.articleDate} dateTime={data.date}>
          Atualizado em: {weekday}, {dataModificada} às {horaModificada}
        </time>
      )}
    </>
  );
};
